'use strict';
import isFunction from 'lodash/isFunction';
import moment from 'moment';


export class TimePicker {
  constructor(onSelect, initialValue) {
    this.timeOffsets = [0, 0];
    this.time = {};
    this.value = initialValue;
    this.onSelect = onSelect;
  }

  init(minute, hour) {
    // default stepper increments
    minute = minute || 0;
    hour = hour || 0;

    if (minute === 0 && hour === 0) {
      this.selected = moment(this.value || new Date());
      this.timeOffsets[0] = this.selected.minute();
      this.timeOffsets[1] = this.selected.hour();
    } else {
      this.timeOffsets[0] += minute;
      if (this.timeOffsets[0] > 59) {
        this.timeOffsets[0] = 0;
      } else if (this.timeOffsets[0] < 0) {
        this.timeOffsets[0] = 59;
      }
      this.timeOffsets[1] += hour;
      if (this.timeOffsets[1] > 23) {
        this.timeOffsets[1] = 0
      } else if (this.timeOffsets[1] < 0) {
        this.timeOffsets[1] = 23
      }
    }

    // create valid moment to parse time
    var h = this.timeOffsets[1], // 24 hour clock = 0 to 23
      m = this.timeOffsets[0];

    // period headings - this can live outside init() but needs to trigger on language change
    this.meridiem = {
      AM: moment('00:00', 'hh:mm').format('A'),
      PM: moment('12:00', 'hh:mm').format('A')
    };

    // selectedTime used by picker clock
    this.time = {
      h: h === 0 ? 12 : h <= 12 ? h : h - 12,
      m: m,
      p: h < 12 ? 'AM' : 'PM'
    };

    // minutes are strings (single digits have leading zero)
    this.time.m = this.time.m < 10 ? '0' + this.time.m : this.time.m.toString();

    // parse value
    this.setClock();
  }

  setSelected(period, value) {
    this.time[period] = value.value;
    this.setClock();
  }

  select() {
    this.value = new Date(this.selected.valueOf());
    if (isFunction(this.onSelect)) this.onSelect(this.value);
  }

  clear() {
    this.value = null;
    if (isFunction(this.onSelect)) this.onSelect(this.value);
  }

  // preserve original date
  now() {
    var now = moment();
    this.value = moment(this.selected).hour(now.hour()).minute(now.minute()).seconds(0);
    this.init();
  }

  setClock() {
    this.clock = {
      hours: [],
      minutes: [],
      periods: []
    };

    for (var i = 0; i < 12; i++) {
      var h = i + 1,
        m = i * 5,
        p = i === 0 ? 'AM' : 'PM';
      this.clock.hours.push({value: h, selected: h === this.time.h});
      this.clock.minutes.push({
        value: _minuteString(m),
        selected: _minuteSelected(m, this.time.m)
      });
      if (i < 2) {
        this.clock.periods.push({value: p, selected: p === this.time.p}); // meridiem
      }
    }

    // make it a 24 our clock - set correct hours for 12AM/PM - 12:00AM = 0, 12:00PM = 12
    if (this.time.h === 12) {
      h = this.time.p === 'AM' ? 0 : 12;
    } else {
      h = this.time.p === 'AM' ? this.time.h : this.time.h + 12;
    }
    // keep steppers in sync
    this.timeOffsets = [parseInt(this.time.m), h];
    this.selected = moment(this.selected).hour(this.timeOffsets[1]).minute(this.timeOffsets[0]).seconds(0);

    function _minuteSelected(m, selected) {
      selected = selected === 0 ? 0 : 5 * Math.round(selected / 5);
      if (selected === 60) selected = 0;
      return m === selected;
    }

    function _minuteString(m) {
      return m < 10 ? '0' + m : m.toString();
    }

    //console.log('set the clock:', this.clock)
  }
}



// WEBPACK FOOTER //
// ./src/js/core-components/android-date-time-pickers/TimePicker.js